import React from 'react';

const DashboardConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  //  IF YOU HAVE NO ROLE FOR DASHBOARD = INFITE LOOP AT LOGIN
  auth: ['ROLE_USER'],
  routes: [
    {
      path: '/dashboard',
      exact: true,
      component: React.lazy(() => import('./dashboard_home'))
    },
    {
      path: '/dashboard/news/water_fall',
      component: React.lazy(() => import('./dashboard_news_water_fall'))
    },
    {
      path: '/dashboard/press/water_fall',
      component: React.lazy(() => import('./dashboard_press_water_fall'))
    }
  ]
};

// Notifications

const DashboardNotificationsConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_MESSAGE', 'ROLE_MESSAGE_LIST', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      path: '/dashboard/notifications',
      exact: true,
      component: React.lazy(() => import('./dashboard_notifications'))
    }
  ]
};

const DashboardNotificationsAddConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_MESSAGE', 'ROLE_MESSAGE_ADD', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      path: '/dashboard/notifications/add',
      component: React.lazy(() => import('./dashboard_notifications_edit'))
    }
  ]
};

const DashboardNotificationsEditConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_MESSAGE', 'ROLE_MESSAGE_EDIT', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      path: '/dashboard/notifications/:id',
      component: React.lazy(() => import('./dashboard_notifications_edit'))
    }
  ]
};

// News

const DashboardNewsConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_NEWS', 'ROLE_NEWS_LIST', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      path: '/dashboard/news',
      exact: true,
      component: React.lazy(() => import('./dashboard_news'))
    }
  ]
};

const DashboardNewsAddConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_NEWS', 'ROLE_NEWS_ADD', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      path: '/dashboard/news/add',
      component: React.lazy(() => import('./dashboard_news_edit'))
    }
  ]
};

const DashboardNewsEditConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_NEWS', 'ROLE_NEWS_EDIT', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      path: '/dashboard/news/:id',
      component: React.lazy(() => import('./dashboard_news_edit'))
    }
  ]
};

// SLIDES

const DashboardSlidesConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_HEADER', 'ROLE_HEADER_LIST', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      path: '/dashboard/slides',
      exact: true,
      component: React.lazy(() => import('./dashboard_slides'))
    }
  ]
};

const DashboardSlidesAddConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_HEADER', 'ROLE_HEADER_ADD', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      path: '/dashboard/slides/add',
      component: React.lazy(() => import('./dashboard_slides_create'))
    }
  ]
};

const DashboardSlidesEditConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_HEADER', 'ROLE_HEADER_EDIT', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      path: '/dashboard/slides/:id',
      component: React.lazy(() => import('./dashboard_slides_edit'))
    }
  ]
};

export {
  DashboardConfig,
  DashboardSlidesConfig,
  DashboardSlidesAddConfig,
  DashboardSlidesEditConfig,
  DashboardNewsConfig,
  DashboardNewsAddConfig,
  DashboardNewsEditConfig,
  DashboardNotificationsConfig,
  DashboardNotificationsAddConfig,
  DashboardNotificationsEditConfig
};
